export default __webpack_public_path__ + "static/media/nathanFreelancerFeedback.48768c44.png";